import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { AlertTriangle } from "lucide-react";

interface Props {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  targets: { name: string; itemCount?: number }[];
  onConfirm: () => void;
}

export function DeleteConfirmDialog({ open, onOpenChange, targets, onConfirm }: Props) {
  const nonEmpty = targets.filter((t) => (t.itemCount ?? 0) > 0);
  const primary = nonEmpty[0];
  const description =
    targets.length === 1
      ? primary
        ? `This folder contains ${primary.itemCount} items. Deletion is permanent — vaultwisp has no recovery once confirmed.`
        : "This item will be deleted permanently."
      : `${targets.length} items will be deleted, including ${nonEmpty.length} non-empty folder${nonEmpty.length === 1 ? "" : "s"}. Deletion is permanent.`;

  const title =
    targets.length === 1
      ? `Delete "${targets[0]!.name}"?`
      : `Delete ${targets.length} items?`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-destructive/15 text-destructive">
            <AlertTriangle size={18} />
          </div>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            className="bg-danger text-primary-foreground hover:bg-danger/90"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
